import { useEffect, useRef } from "react";
import gsap from "gsap";
import BaseLayout from "../layouts/BaseLayout";

export default function Contact() {
  const lineRef = useRef(null);
  const leftContentRef = useRef(null);
  const rightContentRef = useRef(null);

  useEffect(() => {
    const tl = gsap.timeline();

    gsap.set(leftContentRef.current, { opacity: 0, x: 40 });
    gsap.set(lineRef.current, { x: 0 });
    gsap.set(rightContentRef.current, { opacity: 1 });

    tl.to({}, { duration: 0.3 })

      .to(lineRef.current, {
        x: "-40vw",
        duration: 0.9,
        ease: "power3.inOut",
      })

      .to(
        leftContentRef.current,
        {
          opacity: 1,
          x: 0,
          duration: 0.6,
          ease: "power3.out",
        },
        "-=0.4",
      )

      .to(lineRef.current, {
        x: 0,
        duration: 0.8,
        ease: "power3.inOut",
      });
  }, []);

  return (
    <BaseLayout>
      <main className="relative min-h-screen px-24 py-32 text-neutral-100">
        <div ref={leftContentRef} className="max-w-xl">
          <h1 className="text-4xl tracking-wide mb-10">
            Let’s build something great
          </h1>

          <div className="space-y-6 text-sm text-neutral-300">
            <a
              href="mailto:tatianekelli.dev@gmail.com"
              className="flex items-center gap-4 hover:text-white transition"
            >
              <span>✉</span>
              tatianekelli.dev@gmail.com
            </a>

            <a
              href="https://www.linkedin.com/in/tatiane-kelli"
              target="_blank"
              rel="noreferrer"
              className="flex items-center gap-4 hover:text-white transition"
            >
              <span>in</span>
              /tatiane-kelli
            </a>
          </div>
        </div>

        <div
          ref={lineRef}
          className="absolute top-1/2 right-[30%] h-[60%] w-px bg-neutral-500 -translate-y-1/2"
        />

        <div
          ref={rightContentRef}
          className="absolute right-24 top-1/2 max-w-xs text-sm text-neutral-400 -translate-y-1/2"
        >
          Crafted with intention, <br />
          built to endure.
        </div>
      </main>
    </BaseLayout>
  );
}
